<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="ewb-footer-hd">
      <div class="containers clearfix">
        <div class="col-lg-6 ewb-footer-info col-lg-offset-1 col-sm-12">
          <div class="footCenter">
            <img src="@/components/img/footLogo.png" alt="" class="footImg1" />
            <img src="@/components/img/footLogo2.png" alt="" class="footImg2" />
          </div>
        </div>
        <ul class="col-lg-5 ewb-footer-list">
          <ul class="ewb-work-list clearfix">
            <li>
              <h3>
                台北オフィス：台湾台北市大安区信義路四段306号6階<br />
                昆山オフィス：中国江蘇省昆山市同豊東路1225号<br />
                海安工場：中国江蘇省南通市海安経済技術開発区日月潭路889号<br />
                連絡用メールアドレス：business@fesagrp.com
              </h3>
            </li>
          </ul>
        </ul>
      </div>
    </div>
    <footer>
      <div class="container-fluid">
        <div class="container">
          <p>
            版權所有：華胤鋼結構工程（江蘇）有限公司&nbsp;備案序號：<a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color: #fff"
              >蘇ICP備2023025063號</a
            >
          </p>
        </div>
      </div>
    </footer>

    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import Loader from '../skip/Loader.vue'
export default {
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    Loader,
  },
}
</script>

<style scoped>
body::-webkit-scrollbar {
  width: 0;
  height: 8px;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Add a thumb */
body::-webkit-scrollbar-thumb {
  background: rgba(250, 250, 250, 0.5);
}

body,
html {
  height: 100%;
  min-height: 100%;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}

ol,
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none !important;
}
.col-xs-4,
.col-sm-4,
.col-lg-4 {
  padding: 0 15px;
}
footer {
  width: 100%;
  height: 80px;
  background-color: #313131;
}

footer p {
  text-align: center;
  color: #fff;
  font-weight: 200;
  font-size: 13px;
  text-transform: uppercase;
  padding-top: 33px;
  letter-spacing: 0.5px;
}

footer a {
  color: #aaa;
  text-decoration: none;
}

footer a:hover {
  text-decoration: none;
  color: #aaa;
}
.ewb-footer-hd {
  padding-bottom: 10px;
  min-height: 192px;
  background-color: #313131;
}
.containers {
  margin-right: auto;
  margin-left: auto;
  padding-top: 20px;
}
.ewb-footer-info {
  float: left;
  padding-top: 40px;
}
.ewb-work-time {
  margin-top: 10px;
  padding-left: 28px;
  height: 56px;
  line-height: 56px !important;
  font-size: 28px;
  color: #fff;
}
.ewb-footer-list {
  float: left;
  margin: 16px 0 0 48px;
}

.ewb-work-list > li {
  padding-left: 10px;
  /* width: 194px; */
  width: auto;
  vertical-align: top;
}
.ewb-work-list > li > h2 {
  height: 26px;
  line-height: 26px;
  color: #fff;
  font-size: 26px;
  margin-top: 10px;
  font-weight: bolder;
}

.ewb-work-list > li > h3 {
  height: 30px;
  line-height: 26px;
  color: #fff;
  font-size: 17px;
  margin-top: 5px;
}

.ewb-footer-list {
  float: left;
  margin: 30px 0 0 0px;
}
.ewb-footer-tt {
  height: 48px;
  line-height: 48px;
  font-size: 20px;
}
.ewb-footer-tt > a,
.ewb-footer-name > a {
  color: #fff;
}
.ewb-footer-name {
  height: 29px;
  line-height: 29px;
  vertical-align: top;
}
.footImg1 {
  height: 5vw;
  max-height: 100px;
  display: inline-block;
  margin-right: 80px;
}
.footImg2 {
  height: 5vw;
  max-height: 85px;
  display: inline-block;
}

.footCenter {
  margin: 0 auto;
  border-right: 1px solid #fff;
  height: 100px;
}

@media screen and (max-width: 1400px) {
  .ewb-work-list > li > h2 {
    font-size: 18px;
  }
  .ewb-work-list > li > h3 {
    font-size: 17px;
    height: auto;
    line-height: 30px;
    font-weight: normal;
  }
  .ewb-work-list > li {
    padding-left: 5px;
  }
  .work-grids {
    height: auto !important;
  }
  .ewb-footer-info {
    width: 100%;
    font-size: 17px;
    padding: 0 !important;
  }
  .ewb-footer-list {
    float: left !important;
    margin: 0 !important;
    padding: 10px 0px 10px 26px !important;
    width: 100%;
  }
  .container-fluid p {
    padding-top: 15px;
  }
  .ewb-footer-tt {
    font-size: 17px;
  }
  .footImg1 {
    height: 14vh;
    max-height: 100px;
    display: inline-block;
    margin-right: 0px;
    margin-left: 30px;
    margin-bottom: 20px;
  }
  .footImg2 {
    height: 11vh;
    max-height: 100px;
    display: inline-block;
    margin-right: 0px;
    margin-left: 50px;
    margin-bottom: 20px;
  }
  .footCenter {
    border-right: none;
    height: 110px;
  }
}

@media screen and (max-width: 768px) {
  .ewb-work-list > li > h2 {
    font-size: 18px;
  }
  .ewb-work-list > li > h3 {
    font-size: 13px;
    height: auto;
    line-height: 25px;
    font-weight: normal;
  }
  .ewb-work-list > li {
    padding-left: 5px;
  }
  .work-grids {
    height: auto !important;
  }
  .ewb-footer-info {
    width: 100%;
    font-size: 17px;
    padding: 0 !important;
  }
  .ewb-footer-list {
    float: left !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
  }
  .container-fluid p {
    padding-top: 15px;
  }
  .ewb-footer-tt {
    font-size: 17px;
  }
  .footImg1 {
    height: 68px;
    max-height: 100px;
    display: block;
    margin-right: 0px;
    margin-left: 15px;
    margin-bottom: 20px;
  }
  .footImg2 {
    height: 65px;
    max-height: 100px;
    display: block;
    margin-right: 0px;
    margin-left: 15px;
    margin-bottom: 20px;
  }
  .footCenter {
    border-right: none;
    height: 170px;
  }
}
@media screen and (min-width: 2000px) {
  .ewb-work-time {
    font-size: 40px;
  }
  .ewb-work-list > li > h3 {
    height: 35px;
    line-height: 40px;
    font-size: 25px;
  }
  .ewb-footer-tt {
    font-size: 30px;
  }
  .ewb-footer-name {
    font-size: 20px;
  }
  .footCenter {
    height: 155px;
  }
  .footImg1 {
    max-height: 140px;
  }
  .footImg2 {
    max-height: 110px;
  }
}
</style>
